import React, { Component } from "react";
import Table from "react-table";
import selectTableHOC from "react-table/lib/hoc/selectTable";
import {CERTIFICATE_STATUS} from "../constants/Constants";
import {Button} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faRecycle } from "@fortawesome/free-solid-svg-icons";
import "./UpgradeDeviceTable.css"

const SelectTable = selectTableHOC(Table);

export default class UpgradeDeviceTable extends Component {
    static defaultProps = {
        keyField: "id"
    };

    state= {
        selectAll: false,
        selection: [],
    };

    columns = [
        {
            Header: "MAC",
            accessor: "mac"
        },
        {
            Header: "Name",
            accessor: "name"
        },
        {
            Header: "Type",
            accessor: "type"
        },
        {
            Header: "Subtype",
            accessor: "subType"
        },
        {
            Header: "Connected",
            accessor: "connected",
            Cell: (row) => (
                 (row.original.connected) ? "Connected" : "Disconnected"
            )
        },
        {
            Header: "Load Level",
            accessor: "loadLevel"
        },
        {
            Header: "Firmware Version",
            accessor: "firmwareVersion"
        },
        {
            Header: "Image Version",
            accessor: "imageVersion"
        }
        ,
        {
            Header: "Wifi Version",
            accessor: "wifiVersion"
        },
        {
            Header: "Certificate Status",
            Cell: (row) => 
            (<div class='parent'>
                <div class="element-left">{row.original.certificateStatus + ":" }</div>
                { (row.original.certificateStatus && row.original.certificateStatus === CERTIFICATE_STATUS.INACTIVE) ?       
                    <Button  size="sm" variant="success" type="submit" onClick={() => this.props.activateDevice(row.original.mac)}>
                        {"Activate"}
                    </Button>   :
                    <Button  size="sm" variant="danger"  type="reset" onClick={() => this.props.deactivateDevice(row.original.mac)}>
                        {"Deactivate"}
                    </Button> 
                }
            </div>),
            width: 150
        },
        {
            Header: "Config",
            Cell: (row) => 
            ((row.original.mac) ? ( 
                <Button variant="info" onClick = {()=>this.checkDeviceClicked(row.original)}><FontAwesomeIcon icon={faCog}/></Button>
            )
            :
                null),
            width: 50
        },
        {
            Header: "Reboot",
            Cell: (row) => ((row.original.mac)? (
                <Button variant="info" onClick = {()=>this.props.onRebootClicked(row.original.mac)}><FontAwesomeIcon icon={faRecycle}/></Button>)
                :
                 null ),
                width: 50
        },
    ];

    checkDeviceClicked(data){
        if(data.mac){  
            this.props.onConfigClicked(data.mac, true);
        }else{
            this.props.onConfigClicked(null, false);
        }
    };

    componentDidUpdate(prevProps) {
        if(this.props != prevProps && this.props.deviceList != prevProps.deviceList){
            this.setState({selection: [], selectAll: false})
        } 
    }


    handleUpgradeClick(e, row) {
        this.props.onClick("upgrade", row);
    }

    handleOnSelection(selection) {
        let upgradeDevices = [], upgradeAc = [];
        for (let i = 0; i < selection.length; i++) {
            let item = selection[i];
            const deviceId = item.slice(item.indexOf("-") + 1, item.length);
            const deviceObj = this.getDeviceObj(deviceId)
            const selectedMAC = deviceObj.mac;
            if(deviceObj.type === "Switch") {
                upgradeDevices.push(selectedMAC);
            } else {
                upgradeAc.push(selectedMAC);
            }    
        }

        this.props.onSelection(upgradeDevices, upgradeAc)
    }

    getDeviceObj(deviceId) {
        for(const device of this.props.deviceList) {
            if(device.id == deviceId) {
                return device;
            }
        }
    }

    /**
     * Toggle a single checkbox for select table
     */
    toggleSelection = (key, shift, row) => {
        // start off with the existing state
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);

        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            // it does not exist so add it
            selection.push(key);
        }
        // update the state
        this.setState({selection});
        this.handleOnSelection(selection)
    };

    /**
     * Toggle all checkboxes for select table
     */
    toggleAll = () => {
        const {keyField} = this.props;
        const selectAll = !this.state.selectAll;
        const selection = [];

        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            // we just push all the IDs onto the selection array
            currentRecords.forEach(item => {
                if (item._original[keyField]) {
                    selection.push(`select-${item._original[keyField]}`);
                }
            });
        }
        this.setState({selectAll, selection});
        this.handleOnSelection(selection)
    };

    /**
     * Whether or not a row is selected for select table
     */
    isSelected = key => {
        return this.state.selection.includes(`select-${key}`);
    };

    rowFn = (state, rowInfo, column, instance) => {
        const {selection} = this.state;
        return {
            onClick: (e, handleOriginal) => {
                
                // IMPORTANT! React-Table uses onClick internally to trigger
                // events like expanding SubComponents and pivots.
                // By default a custom 'onClick' handler will override this functionality.
                // If you want to fire the original onClick handler, call the
                // 'handleOriginal' function.
                if (handleOriginal) {
                    handleOriginal();
                }
            },
            style: {
                background:
                    rowInfo &&
                    selection.includes(`select-${rowInfo.original.id}`) &&
                    "lightgreen"
            }
        };
    };


    render() {
        return (
            <SelectTable
                columns={this.columns}
                data={this.props.deviceList}
                keyField="id"
                ref={r => (this.checkboxTable = r)}
                toggleSelection={this.toggleSelection}
                selectAll={this.state.selectAll}
                selectType="checkbox"
                defaultPageSize={100}
                toggleAll={this.toggleAll}
                isSelected={this.isSelected}
                getTrProps={this.rowFn}
                onSelection={this.handleOnSelection}
            />
        )
    }
}